module.exports = __webpack_public_path__ + "img/whiteLogo.bf3e715b.png";